import React, { useEffect, useContext, memo } from "react";
import { GET_ALL_VALIDATION_T, PAGE_T } from "../../types";
import PageLooperContext from "../../providers/PageLooperContext";
import { common } from "@mui/material/colors";
import PageContentProduitProvince from "./PageContentProduitProvince";

// Définir une interface pour le nouveau format de données
interface MarcheCollectes {
    marche: string;
    collectes: GET_ALL_VALIDATION_T[];
}

const PrixProduitMarcheParProvinces: React.FC<{ produit: string }> = memo(({ produit }) => {
    const { setPages, pages, apiData } = useContext(PageLooperContext);

    useEffect(() => {
        const loadData = async () => {
            const alreadyExists = pages.some((p) => p.id.startsWith(`prix-${produit}-`));
            if (alreadyExists) return;

            // Filtrer toutes les données pour le produit spécifié
            const res = apiData.filter((p) => p.produit?.nomProduit === produit);

            // Regrouper toutes les collectes par marché
            const marcheMap = new Map<string, GET_ALL_VALIDATION_T[]>();
            res.forEach((p) => {
                if (!p.marche || !p.marche.nomMarche) {
                    return;
                }
                const collectes = marcheMap.get(p.marche?.nomMarche) || [];
                collectes.push(p);
                marcheMap.set(p.marche?.nomMarche, collectes);
            });

            // Convertir le Map en un tableau structuré pour le composant enfant
            const collectesParMarche: MarcheCollectes[] = Array.from(marcheMap.entries()).map(([marche, collectes]) => ({
                marche,
                collectes,
            }));

            // Récupérer toutes les régions distinctes pour ce produit
            // En se basant sur la première collecte de chaque groupe pour déterminer la région
            const provinces = Array.from(new Set(collectesParMarche.map((p) => p.collectes[0].marche?.commune?.departement?.province?.nom)));

            // Créer toutes les pages dynamiques en passant les données regroupées
            const newPages = provinces.map((province) => {
                const dataParprovince = collectesParMarche.filter((p) => p.collectes[0].marche?.commune?.departement?.province?.nom === province);

                // console.log('dataParprovince : ', dataParprovince);

               return {
    id: `prix-${produit}-${province}`,
    component: (
        <PageContentProduitProvince
            produit={produit}
            province={province}
            data={dataParprovince}
        />
    ),
    duration: 15000,
};

                // return {
                //     id: `prix-${produit}-${province}`,
                //     component: (
                //         <PageContentProduitprovince
                //             produit={produit}
                //             province={province}
                //             data={dataParprovince}
                //         />
                //     ),
                //     duration: 15000,
                // };
            });

            // Mettre à jour les pages en retirant la page de préchargement
            // setPages((prev: PAGE_T[]) => {
            //     const filtered = prev.filter(
            //         (p) => !(p.id === `PrixProduitMarcheParprovince ${produit}`)
            //     );
            //     return [...filtered, ...newPages];
            // });
            setPages((prev: PAGE_T[]) => {
                const filtered = prev.filter(
                    (p) => !(p.id === `PrixProduitMarcheParprovince ${produit}`)
                );
                return [...filtered, ...newPages];
            });
        };

        loadData();
    }, [produit, setPages, apiData, pages]);

    return null;
});

export default PrixProduitMarcheParProvinces;